import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { authContext } from '../../Context/Authentication';
import './Sidebar.css';

export default function Sidebar({ isOpen, toggleSidebar }) {
  const { Token } = useContext(authContext);

const mainMenuItems = [
  { to: "/Dashboard", icon: "bi-house-door-fill", label: "لوحة التحكم", exact: true },
  { to: "/categories", icon: "bi-folder-fill", label: "الأقسام" },
  { to: "/brands", icon: "bi-tag-fill", label: "الماركات" },
  { to: "/products", icon: "bi-box-seam-fill", label: "المنتجات" },
  { to: "/suppliers", icon: "bi-truck", label: "الموردين" },
  { to: "/customers", icon: "bi-people-fill", label: "العملاء" },
];

const transactionItems = [
  { to: "/purchases", icon: "bi-cart-check-fill", label: "المشتريات" },
  { to: "/sales", icon: "bi-receipt", label: "المبيعات" },
  { to: "/create-bulk-sale", icon: "bi-receipt", label: "التحصيل من العملاء" },
  { to: "/expense", icon: "bi-wallet2", label: "المصروفات" },
  { to: "/income", icon: "bi-piggy-bank-fill", label: "المكافآت" },
];

// 🎯 قسم جديد خاص بالأرصدة الافتتاحية
const openingBalanceItems = [
  { to: "/open-balance", icon: "bi-clipboard-data", label: " رصيد المنتجات الافتتاحي" },
  { to: "/balance-suppliers", icon: "bi-credit-card-2-back-fill", label: " رصيد الموردين الافتتاحي" },
  { to: "/balance-customers", icon: "bi-wallet-fill", label: "رصيد العملاء الافتتاحي" },
];

const analyticsItems = [
  { to: "/net", icon: "bi-graph-up-arrow", label: "صافي الربح" },
  { to: "/topprofits", icon: "bi-currency-dollar", label: "أعلى الأرباح" },
  { to: "/topselling", icon: "bi-trophy-fill", label: "الأكثر مبيعًا" },
  { to: "/topsupplier", icon: "bi-award-fill", label: "أفضل الموردين" },
  { to: "/topcustomer", icon: "bi-star-fill", label: "أفضل العملاء" },
  { to: "/inventoryvalue", icon: "bi-cash-stack", label: "رصيد المخزون" },

  { to: "/supplierfinancial", icon: "bi-cash-stack", label: " اجمالي مصاريف المورد" },
  { to: "/customerfinancial", icon: "bi-cash-stack", label: " اجمالي مصاريف العميل" },
];

  if (!Token) return null;

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={toggleSidebar}
      />

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? '' : 'collapsed'} ${isOpen ? 'mobile-open' : ''}`}>
        {/* Main Menu */}
        <div className="sidebar-section">
          <div className="sidebar-section-title">
            القائمة الرئيسية
          </div>
          <nav>
            {mainMenuItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                className="sidebar-link"
              >
                <i className={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Transactions */}
        <div className="sidebar-section">
          <div className="sidebar-section-title">
            المعاملات
          </div>
          <nav>
            {transactionItems.map((item) => (
              <NavLink key={item.to} to={item.to} className="sidebar-link">
                <i className={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        {/* 🎯 Opening Balances - قسم جديد */}
        <div className="sidebar-section">
          <div className="sidebar-section-title">
            الأرصدة الافتتاحية
          </div>
          <nav>
            {openingBalanceItems.map((item) => (
              <NavLink key={item.to} to={item.to} className="sidebar-link">
                <i className={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Analytics */}
        <div className="sidebar-section">
          <div className="sidebar-section-title">التحليلات</div>
          <nav>
            {analyticsItems.map((item) => (
              <NavLink key={item.to} to={item.to} className="sidebar-link">
                <i className={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
}